function config() {
    this.api_url = 'https://htweixiu.htfa.cn';
    this.img_url = 'https://htweixiu.htfa.cn';
    this.order_url = 'wss://parking.xcxcxcx.com/ws/biz/order';
    // this.api_url = '';
    // this.img_url = '';
    // this.order_url = 'wss://parking.xcxcxcx.com/ws/biz/order';
}
export default new config;